/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/internalCompareFlagsAcrossEnvironmentsOverrides';
import type { InternalCompareFlagsAcrossEnvironmentsQueryParams } from '../../operation-overrides/internalCompareFlagsAcrossEnvironmentsOverrides';

export type InternalCompareFlagsAcrossEnvironmentsPathParams = NonNullable<
  operations['internalCompareFlagsAcrossEnvironments']['parameters']['path']
>;
export type { InternalCompareFlagsAcrossEnvironmentsQueryParams };

export interface Input extends InternalCompareFlagsAcrossEnvironmentsPathParams {
  apiVersion?: string;
  query: InternalCompareFlagsAcrossEnvironmentsQueryParams;
}

export async function internalCompareFlagsAcrossEnvironments(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/flags/compare', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
